/* Derived from the official Color-Chart-LOOP-2026.pdf regular 400 ml chart. */
window.NEKAS_LOOP_400ML_COLORS = Object.freeze([
  {
    "name": "WHITE",
    "code": "LP-100",
    "hex": "#FFFFFF",
    "column": 1,
    "position": 1
  },
  {
    "name": "GLOSS WHITE",
    "code": "LP-101",
    "hex": "#FFFFFF",
    "column": 1,
    "position": 2
  },
  {
    "name": "BLACK MATT",
    "code": "LP-103",
    "hex": "#0D0E0E",
    "column": 1,
    "position": 3
  },
  {
    "name": "BLACK",
    "code": "LP-104",
    "hex": "#040606",
    "column": 1,
    "position": 4
  },
  {
    "name": "BLACK GLOSS",
    "code": "LP-105",
    "hex": "#040606",
    "column": 1,
    "position": 5
  },
  {
    "name": "METALLIZED BLACK",
    "code": "LP-450",
    "hex": "#546267",
    "column": 1,
    "position": 6
  },
  {
    "name": "MADRID",
    "code": "LP-106",
    "hex": "#FFF870",
    "column": 1,
    "position": 7
  },
  {
    "name": "BARCELONA",
    "code": "LP-107",
    "hex": "#FFF44C",
    "column": 1,
    "position": 8
  },
  {
    "name": "VALENCIA",
    "code": "LP-108",
    "hex": "#FCD405",
    "column": 1,
    "position": 9
  },
  {
    "name": "SEVILLA",
    "code": "LP-109",
    "hex": "#F9B00B",
    "column": 1,
    "position": 10
  },
  {
    "name": "MALAGA",
    "code": "LP-110",
    "hex": "#F8A327",
    "column": 1,
    "position": 11
  },
  {
    "name": "AMSTERDAM",
    "code": "LP-120",
    "hex": "#F79136",
    "column": 1,
    "position": 12
  },
  {
    "name": "HARLEM",
    "code": "LP-121",
    "hex": "#F57D2A",
    "column": 1,
    "position": 13
  },
  {
    "name": "UTRECHT",
    "code": "LP-122",
    "hex": "#DF6713",
    "column": 1,
    "position": 14
  },
  {
    "name": "BRUSSELS",
    "code": "LP-131",
    "hex": "#C44D13",
    "column": 1,
    "position": 15
  },
  {
    "name": "ROTTERDAM",
    "code": "LP-123",
    "hex": "#A83013",
    "column": 1,
    "position": 16
  },
  {
    "name": "EINDHOVEN",
    "code": "LP-124",
    "hex": "#FCD4A3",
    "column": 1,
    "position": 17
  },
  {
    "name": "BREDA",
    "code": "LP-125",
    "hex": "#F79949",
    "column": 1,
    "position": 18
  },
  {
    "name": "HELMOND",
    "code": "LP-126",
    "hex": "#F68138",
    "column": 1,
    "position": 19
  },
  {
    "name": "ROSENDHAL",
    "code": "LP-127",
    "hex": "#F47216",
    "column": 1,
    "position": 20
  },
  {
    "name": "ARNHEM",
    "code": "LP-128",
    "hex": "#F36518",
    "column": 1,
    "position": 21
  },
  {
    "name": "TILBURG",
    "code": "LP-129",
    "hex": "#F2541B",
    "column": 1,
    "position": 22
  },
  {
    "name": "OSS",
    "code": "LP-130",
    "hex": "#F0431E",
    "column": 1,
    "position": 23
  },
  {
    "name": "MANCHESTER",
    "code": "LP-136",
    "hex": "#EA2926",
    "column": 1,
    "position": 24
  },
  {
    "name": "LIVERPOOL",
    "code": "LP-137",
    "hex": "#CF232B",
    "column": 1,
    "position": 25
  },
  {
    "name": "NEWCASTLE",
    "code": "LP-138",
    "hex": "#B51F2F",
    "column": 1,
    "position": 26
  },
  {
    "name": "YORK",
    "code": "LP-139",
    "hex": "#AE1329",
    "column": 1,
    "position": 27
  },
  {
    "name": "LEEDS",
    "code": "LP-140",
    "hex": "#920D1B",
    "column": 1,
    "position": 28
  },
  {
    "name": "CORK",
    "code": "LP-156",
    "hex": "#640E1E",
    "column": 1,
    "position": 29
  },
  {
    "name": "CAMBRIDGE",
    "code": "LP-141",
    "hex": "#5A1919",
    "column": 1,
    "position": 30
  },
  {
    "name": "BIRMINGHAM",
    "code": "LP-147",
    "hex": "#F78DA0",
    "column": 1,
    "position": 31
  },
  {
    "name": "NOTTINGHAM",
    "code": "LP-148",
    "hex": "#F36568",
    "column": 1,
    "position": 32
  },
  {
    "name": "DERBY",
    "code": "LP-142",
    "hex": "#F14A59",
    "column": 1,
    "position": 33
  },
  {
    "name": "BRISTOL",
    "code": "LP-143",
    "hex": "#E52E3B",
    "column": 1,
    "position": 34
  },
  {
    "name": "BRIGHTON",
    "code": "LP-144",
    "hex": "#CF1730",
    "column": 1,
    "position": 35
  },
  {
    "name": "WATERFORD",
    "code": "LP-153",
    "hex": "#800939",
    "column": 1,
    "position": 36
  },
  {
    "name": "OXFORD",
    "code": "LP-145",
    "hex": "#640B2C",
    "column": 1,
    "position": 37
  },
  {
    "name": "LONDON",
    "code": "LP-146",
    "hex": "#4F081F",
    "column": 1,
    "position": 38
  },
  {
    "name": "LEICESTER",
    "code": "LP-165",
    "hex": "#360510",
    "column": 1,
    "position": 39
  },
  {
    "name": "BADEN",
    "code": "LP-312",
    "hex": "#351610",
    "column": 1,
    "position": 40
  },
  {
    "name": "DUBLIN",
    "code": "LP-150",
    "hex": "#F5E2E1",
    "column": 2,
    "position": 1
  },
  {
    "name": "GALWAY",
    "code": "LP-151",
    "hex": "#F2BFBD",
    "column": 2,
    "position": 2
  },
  {
    "name": "LIMERICK",
    "code": "LP-154",
    "hex": "#F9ABC5",
    "column": 2,
    "position": 3
  },
  {
    "name": "DUNDALK",
    "code": "LP-152",
    "hex": "#F68DB9",
    "column": 2,
    "position": 4
  },
  {
    "name": "SWORDS",
    "code": "LP-155",
    "hex": "#E589C0",
    "column": 2,
    "position": 5
  },
  {
    "name": "SLIGO",
    "code": "LP-157",
    "hex": "#D06694",
    "column": 2,
    "position": 6
  },
  {
    "name": "FARO",
    "code": "LP-158",
    "hex": "#F599D1",
    "column": 2,
    "position": 7
  },
  {
    "name": "BEJA",
    "code": "LP-159",
    "hex": "#F37FC5",
    "column": 2,
    "position": 8
  },
  {
    "name": "COIMBRA",
    "code": "LP-160",
    "hex": "#CF30A0",
    "column": 2,
    "position": 9
  },
  {
    "name": "PORTO",
    "code": "LP-161",
    "hex": "#B9097A",
    "column": 2,
    "position": 10
  },
  {
    "name": "AMADORA",
    "code": "LP-162",
    "hex": "#8B0855",
    "column": 2,
    "position": 11
  },
  {
    "name": "THESSALONIKI",
    "code": "LP-164",
    "hex": "#6B0841",
    "column": 2,
    "position": 12
  },
  {
    "name": "LISBOA",
    "code": "LP-163",
    "hex": "#5B102D",
    "column": 2,
    "position": 13
  },
  {
    "name": "COPENHAGEN",
    "code": "LP-190",
    "hex": "#3F134E",
    "column": 2,
    "position": 14
  },
  {
    "name": "WARSAW",
    "code": "LP-149",
    "hex": "#B30756",
    "column": 2,
    "position": 15
  },
  {
    "name": "VILNIUS",
    "code": "LP-180",
    "hex": "#C1AADB",
    "column": 2,
    "position": 16
  },
  {
    "name": "KALMAR",
    "code": "LP-181",
    "hex": "#A78FCE",
    "column": 2,
    "position": 17
  },
  {
    "name": "MALMO",
    "code": "LP-182",
    "hex": "#917AC4",
    "column": 2,
    "position": 18
  },
  {
    "name": "GOTEBORG",
    "code": "LP-183",
    "hex": "#7260B6",
    "column": 2,
    "position": 19
  },
  {
    "name": "MORA",
    "code": "LP-184",
    "hex": "#483B9D",
    "column": 2,
    "position": 20
  },
  {
    "name": "FALUN",
    "code": "LP-185",
    "hex": "#291C56",
    "column": 2,
    "position": 21
  },
  {
    "name": "STOCKHOLM",
    "code": "LP-186",
    "hex": "#F7DAEF",
    "column": 2,
    "position": 22
  },
  {
    "name": "HELSINKI",
    "code": "LP-187",
    "hex": "#D6ACDB",
    "column": 2,
    "position": 23
  },
  {
    "name": "OULU",
    "code": "LP-188",
    "hex": "#B370BF",
    "column": 2,
    "position": 24
  },
  {
    "name": "OSLO",
    "code": "LP-189",
    "hex": "#A654B0",
    "column": 2,
    "position": 25
  },
  {
    "name": "RIGA",
    "code": "LP-193",
    "hex": "#65265C",
    "column": 2,
    "position": 26
  },
  {
    "name": "SKAGEN",
    "code": "LP-192",
    "hex": "#491B3D",
    "column": 2,
    "position": 27
  },
  {
    "name": "MOSS",
    "code": "LP-191",
    "hex": "#5F3B9F",
    "column": 2,
    "position": 28
  },
  {
    "name": "TALLINN",
    "code": "LP-194",
    "hex": "#48288D",
    "column": 2,
    "position": 29
  },
  {
    "name": "ODENSE",
    "code": "LP-195",
    "hex": "#251745",
    "column": 2,
    "position": 30
  },
  {
    "name": "PARIS",
    "code": "LP-200",
    "hex": "#BEE0E4",
    "column": 2,
    "position": 31
  },
  {
    "name": "NANCY",
    "code": "LP-201",
    "hex": "#9CCED7",
    "column": 2,
    "position": 32
  },
  {
    "name": "MONACO",
    "code": "LP-199",
    "hex": "#8CDAF6",
    "column": 2,
    "position": 33
  },
  {
    "name": "STRASBOURG",
    "code": "LP-202",
    "hex": "#68BEEC",
    "column": 2,
    "position": 34
  },
  {
    "name": "METZ",
    "code": "LP-203",
    "hex": "#3A9EDE",
    "column": 2,
    "position": 35
  },
  {
    "name": "LENS",
    "code": "LP-204",
    "hex": "#1C8CD5",
    "column": 2,
    "position": 36
  },
  {
    "name": "LILLE",
    "code": "LP-205",
    "hex": "#1563A9",
    "column": 2,
    "position": 37
  },
  {
    "name": "RENNES",
    "code": "LP-206",
    "hex": "#13508D",
    "column": 2,
    "position": 38
  },
  {
    "name": "CALAIS",
    "code": "LP-207",
    "hex": "#093964",
    "column": 2,
    "position": 39
  },
  {
    "name": "BREST",
    "code": "LP-208",
    "hex": "#06294A",
    "column": 2,
    "position": 40
  },
  {
    "name": "PERPIGNAN",
    "code": "LP-224",
    "hex": "#03192F",
    "column": 3,
    "position": 1
  },
  {
    "name": "BORDEAUX",
    "code": "LP-209",
    "hex": "#CADCE7",
    "column": 3,
    "position": 2
  },
  {
    "name": "NANTES",
    "code": "LP-210",
    "hex": "#88BBD8",
    "column": 3,
    "position": 3
  },
  {
    "name": "GRENOBLE",
    "code": "LP-211",
    "hex": "#5E93B5",
    "column": 3,
    "position": 4
  },
  {
    "name": "GENEVA",
    "code": "LP-220",
    "hex": "#195478",
    "column": 3,
    "position": 5
  },
  {
    "name": "LYON",
    "code": "LP-212",
    "hex": "#083650",
    "column": 3,
    "position": 6
  },
  {
    "name": "MARSEILLE",
    "code": "LP-213",
    "hex": "#C0E0F2",
    "column": 3,
    "position": 7
  },
  {
    "name": "NIMES",
    "code": "LP-214",
    "hex": "#98CAED",
    "column": 3,
    "position": 8
  },
  {
    "name": "MONTPELLIER",
    "code": "LP-215",
    "hex": "#629ECF",
    "column": 3,
    "position": 9
  },
  {
    "name": "TOULOUSE",
    "code": "LP-216",
    "hex": "#2D6795",
    "column": 3,
    "position": 10
  },
  {
    "name": "TAVERNY",
    "code": "LP-219",
    "hex": "#205B94",
    "column": 3,
    "position": 11
  },
  {
    "name": "NICE",
    "code": "LP-217",
    "hex": "#0F3D72",
    "column": 3,
    "position": 12
  },
  {
    "name": "AJACCIO",
    "code": "LP-218",
    "hex": "#0B1A35",
    "column": 3,
    "position": 13
  },
  {
    "name": "ATHENS",
    "code": "LP-222",
    "hex": "#14394C",
    "column": 3,
    "position": 14
  },
  {
    "name": "LIMASSOL",
    "code": "LP-223",
    "hex": "#192839",
    "column": 3,
    "position": 15
  },
  {
    "name": "BASEL",
    "code": "LP-221",
    "hex": "#1F3781",
    "column": 3,
    "position": 16
  },
  {
    "name": "TORINO",
    "code": "LP-250",
    "hex": "#C4EBE9",
    "column": 3,
    "position": 17
  },
  {
    "name": "COMO",
    "code": "LP-249",
    "hex": "#99DDDA",
    "column": 3,
    "position": 18
  },
  {
    "name": "MILANO",
    "code": "LP-251",
    "hex": "#69CDCA",
    "column": 3,
    "position": 19
  },
  {
    "name": "BERGAMO",
    "code": "LP-252",
    "hex": "#0AABBA",
    "column": 3,
    "position": 20
  },
  {
    "name": "BRESCIA",
    "code": "LP-253",
    "hex": "#0A98A2",
    "column": 3,
    "position": 21
  },
  {
    "name": "VENEZIA",
    "code": "LP-254",
    "hex": "#0C566C",
    "column": 3,
    "position": 22
  },
  {
    "name": "SAN MARINO",
    "code": "LP-248",
    "hex": "#033E4D",
    "column": 3,
    "position": 23
  },
  {
    "name": "BOLZANO",
    "code": "LP-255",
    "hex": "#07252E",
    "column": 3,
    "position": 24
  },
  {
    "name": "PIACENZA",
    "code": "LP-256",
    "hex": "#CCEDD4",
    "column": 3,
    "position": 25
  },
  {
    "name": "PARMA",
    "code": "LP-257",
    "hex": "#A6DFB0",
    "column": 3,
    "position": 26
  },
  {
    "name": "MODENA",
    "code": "LP-258",
    "hex": "#40BB71",
    "column": 3,
    "position": 27
  },
  {
    "name": "REGGIO EMILIA",
    "code": "LP-259",
    "hex": "#2F8954",
    "column": 3,
    "position": 28
  },
  {
    "name": "BOLOGNA",
    "code": "LP-260",
    "hex": "#116931",
    "column": 3,
    "position": 29
  },
  {
    "name": "FERRARA",
    "code": "LP-261",
    "hex": "#0B3820",
    "column": 3,
    "position": 30
  },
  {
    "name": "RIMINI",
    "code": "LP-282",
    "hex": "#072614",
    "column": 3,
    "position": 31
  },
  {
    "name": "LA SPEZIA",
    "code": "LP-262",
    "hex": "#C2E68C",
    "column": 3,
    "position": 32
  },
  {
    "name": "PISA",
    "code": "LP-263",
    "hex": "#A6DD8B",
    "column": 3,
    "position": 33
  },
  {
    "name": "PRATO",
    "code": "LP-264",
    "hex": "#80C883",
    "column": 3,
    "position": 34
  },
  {
    "name": "LUCCA",
    "code": "LP-265",
    "hex": "#519A54",
    "column": 3,
    "position": 35
  },
  {
    "name": "FIRENZE",
    "code": "LP-266",
    "hex": "#1B7529",
    "column": 3,
    "position": 36
  },
  {
    "name": "SIENA",
    "code": "LP-267",
    "hex": "#306F30",
    "column": 3,
    "position": 37
  },
  {
    "name": "LIVORNO",
    "code": "LP-268",
    "hex": "#22591B",
    "column": 3,
    "position": 38
  },
  {
    "name": "PERUGIA",
    "code": "LP-269",
    "hex": "#173C0E",
    "column": 3,
    "position": 39
  },
  {
    "name": "SASSARI",
    "code": "LP-270",
    "hex": "#DCEDDB",
    "column": 3,
    "position": 40
  },
  {
    "name": "CAGLIARI",
    "code": "LP-271",
    "hex": "#BCE0CA",
    "column": 4,
    "position": 1
  },
  {
    "name": "MESSINA",
    "code": "LP-272",
    "hex": "#6EA28D",
    "column": 4,
    "position": 2
  },
  {
    "name": "CATANIA",
    "code": "LP-273",
    "hex": "#14352C",
    "column": 4,
    "position": 3
  },
  {
    "name": "PALERMO",
    "code": "LP-274",
    "hex": "#0A2A22",
    "column": 4,
    "position": 4
  },
  {
    "name": "ROMA",
    "code": "LP-275",
    "hex": "#E0EF86",
    "column": 4,
    "position": 5
  },
  {
    "name": "MORIMONDO",
    "code": "LP-276",
    "hex": "#DEED69",
    "column": 4,
    "position": 6
  },
  {
    "name": "NAPOLI",
    "code": "LP-277",
    "hex": "#BFDF19",
    "column": 4,
    "position": 7
  },
  {
    "name": "SALERNO",
    "code": "LP-278",
    "hex": "#98B713",
    "column": 4,
    "position": 8
  },
  {
    "name": "FOGGIA",
    "code": "LP-279",
    "hex": "#829410",
    "column": 4,
    "position": 9
  },
  {
    "name": "BARI",
    "code": "LP-280",
    "hex": "#636511",
    "column": 4,
    "position": 10
  },
  {
    "name": "CATANZARO",
    "code": "LP-281",
    "hex": "#435718",
    "column": 4,
    "position": 11
  },
  {
    "name": "LECCE",
    "code": "LP-283",
    "hex": "#35491E",
    "column": 4,
    "position": 12
  },
  {
    "name": "ZAGREB",
    "code": "LP-300",
    "hex": "#F7F8A9",
    "column": 4,
    "position": 13
  },
  {
    "name": "BRATISLAVA",
    "code": "LP-301",
    "hex": "#F3EB70",
    "column": 4,
    "position": 14
  },
  {
    "name": "BUCAREST",
    "code": "LP-302",
    "hex": "#DDD755",
    "column": 4,
    "position": 15
  },
  {
    "name": "ISTANBUL",
    "code": "LP-299",
    "hex": "#C5BE05",
    "column": 4,
    "position": 16
  },
  {
    "name": "BUDAPEST",
    "code": "LP-303",
    "hex": "#A4850A",
    "column": 4,
    "position": 17
  },
  {
    "name": "PRAGA",
    "code": "LP-304",
    "hex": "#8D7309",
    "column": 4,
    "position": 18
  },
  {
    "name": "BELGRADE",
    "code": "LP-305",
    "hex": "#4B4D1A",
    "column": 4,
    "position": 19
  },
  {
    "name": "TIRANA",
    "code": "LP-298",
    "hex": "#4B3810",
    "column": 4,
    "position": 20
  },
  {
    "name": "VIENNA",
    "code": "LP-306",
    "hex": "#F2E9B6",
    "column": 4,
    "position": 21
  },
  {
    "name": "KREMS",
    "code": "LP-307",
    "hex": "#DDC68A",
    "column": 4,
    "position": 22
  },
  {
    "name": "LINZ",
    "code": "LP-308",
    "hex": "#C9A565",
    "column": 4,
    "position": 23
  },
  {
    "name": "INNSBRUCK",
    "code": "LP-327",
    "hex": "#A9813E",
    "column": 4,
    "position": 24
  },
  {
    "name": "WELS",
    "code": "LP-309",
    "hex": "#704914",
    "column": 4,
    "position": 25
  },
  {
    "name": "SALZBURG",
    "code": "LP-310",
    "hex": "#432D19",
    "column": 4,
    "position": 26
  },
  {
    "name": "GRAZ",
    "code": "LP-311",
    "hex": "#362D10",
    "column": 4,
    "position": 27
  },
  {
    "name": "BERLIN",
    "code": "LP-313",
    "hex": "#F5D5AB",
    "column": 4,
    "position": 28
  },
  {
    "name": "HAMBURG",
    "code": "LP-314",
    "hex": "#F6BB8D",
    "column": 4,
    "position": 29
  },
  {
    "name": "BREMEN",
    "code": "LP-315",
    "hex": "#F0A16A",
    "column": 4,
    "position": 30
  },
  {
    "name": "LEIPZIG",
    "code": "LP-326",
    "hex": "#DC7848",
    "column": 4,
    "position": 31
  },
  {
    "name": "ZURICH",
    "code": "LP-330",
    "hex": "#BD6A3B",
    "column": 4,
    "position": 32
  },
  {
    "name": "HANNOVER",
    "code": "LP-316",
    "hex": "#BF5C16",
    "column": 4,
    "position": 33
  },
  {
    "name": "DORTMUND",
    "code": "LP-317",
    "hex": "#913910",
    "column": 4,
    "position": 34
  },
  {
    "name": "HALLE",
    "code": "LP-318",
    "hex": "#583114",
    "column": 4,
    "position": 35
  },
  {
    "name": "MUNCHEN",
    "code": "LP-319",
    "hex": "#FCF6C0",
    "column": 4,
    "position": 36
  },
  {
    "name": "STUTTGART",
    "code": "LP-320",
    "hex": "#D2A67F",
    "column": 4,
    "position": 37
  },
  {
    "name": "NURNBERG",
    "code": "LP-321",
    "hex": "#A4653F",
    "column": 4,
    "position": 38
  },
  {
    "name": "BERN",
    "code": "LP-329",
    "hex": "#7E4F31",
    "column": 4,
    "position": 39
  },
  {
    "name": "MAINZ",
    "code": "LP-322",
    "hex": "#672A0B",
    "column": 4,
    "position": 40
  },
  {
    "name": "DUESSELDORF",
    "code": "LP-328",
    "hex": "#461F09",
    "column": 5,
    "position": 1
  },
  {
    "name": "FRANKFURT",
    "code": "LP-323",
    "hex": "#4E2B1B",
    "column": 5,
    "position": 2
  },
  {
    "name": "BONN",
    "code": "LP-324",
    "hex": "#3E2923",
    "column": 5,
    "position": 3
  },
  {
    "name": "KOLN",
    "code": "LP-325",
    "hex": "#3D160A",
    "column": 5,
    "position": 4
  },
  {
    "name": "LOS ANGELES",
    "code": "LP-340",
    "hex": "#DCE0DE",
    "column": 5,
    "position": 5
  },
  {
    "name": "SAN DIEGO",
    "code": "LP-341",
    "hex": "#C9CFD2",
    "column": 5,
    "position": 6
  },
  {
    "name": "SAN JOSE",
    "code": "LP-342",
    "hex": "#A1A9AF",
    "column": 5,
    "position": 7
  },
  {
    "name": "SAN FRANCISCO",
    "code": "LP-343",
    "hex": "#707A84",
    "column": 5,
    "position": 8
  },
  {
    "name": "OAKLAND",
    "code": "LP-344",
    "hex": "#4C515B",
    "column": 5,
    "position": 9
  },
  {
    "name": "SACRAMENTO",
    "code": "LP-345",
    "hex": "#34313B",
    "column": 5,
    "position": 10
  },
  {
    "name": "LONG BEACH",
    "code": "LP-346",
    "hex": "#111319",
    "column": 5,
    "position": 11
  },
  {
    "name": "HOUSTON",
    "code": "LP-347",
    "hex": "#D8C7C7",
    "column": 5,
    "position": 12
  },
  {
    "name": "SAN ANTONIO",
    "code": "LP-348",
    "hex": "#A88D9C",
    "column": 5,
    "position": 13
  },
  {
    "name": "DALLAS",
    "code": "LP-349",
    "hex": "#795865",
    "column": 5,
    "position": 14
  },
  {
    "name": "AUSTIN",
    "code": "LP-350",
    "hex": "#563D46",
    "column": 5,
    "position": 15
  },
  {
    "name": "EL PASO",
    "code": "LP-351",
    "hex": "#322225",
    "column": 5,
    "position": 16
  },
  {
    "name": "MELBOURNE",
    "code": "LP-370",
    "hex": "#F8B6A6",
    "column": 5,
    "position": 17
  },
  {
    "name": "SYDNEY",
    "code": "LP-371",
    "hex": "#D8988C",
    "column": 5,
    "position": 18
  },
  {
    "name": "BRISBANE",
    "code": "LP-372",
    "hex": "#C78579",
    "column": 5,
    "position": 19
  },
  {
    "name": "CHRISTCHURCH",
    "code": "LP-373",
    "hex": "#A97874",
    "column": 5,
    "position": 20
  },
  {
    "name": "WELLINGTON",
    "code": "LP-374",
    "hex": "#7F413E",
    "column": 5,
    "position": 21
  },
  {
    "name": "MOSCOW",
    "code": "LP-375",
    "hex": "#F68A7C",
    "column": 5,
    "position": 22
  },
  {
    "name": "ST. PETERSBURG",
    "code": "LP-376",
    "hex": "#F57663",
    "column": 5,
    "position": 23
  },
  {
    "name": "KRASNODAR",
    "code": "LP-377",
    "hex": "#F2583D",
    "column": 5,
    "position": 24
  },
  {
    "name": "NEW YORK",
    "code": "LP-352",
    "hex": "#D5D6E4",
    "column": 5,
    "position": 25
  },
  {
    "name": "BOSTON",
    "code": "LP-353",
    "hex": "#C5C3DB",
    "column": 5,
    "position": 26
  },
  {
    "name": "CHICAGO",
    "code": "LP-354",
    "hex": "#A9A5C7",
    "column": 5,
    "position": 27
  },
  {
    "name": "INDIANAPOLIS",
    "code": "LP-368",
    "hex": "#7C75A5",
    "column": 5,
    "position": 28
  },
  {
    "name": "PHILLY",
    "code": "LP-355",
    "hex": "#444179",
    "column": 5,
    "position": 29
  },
  {
    "name": "WASHINGTON",
    "code": "LP-356",
    "hex": "#282952",
    "column": 5,
    "position": 30
  },
  {
    "name": "MIAMI",
    "code": "LP-357",
    "hex": "#D8D5CE",
    "column": 5,
    "position": 31
  },
  {
    "name": "ORLANDO",
    "code": "LP-358",
    "hex": "#AAA8A2",
    "column": 5,
    "position": 32
  },
  {
    "name": "TAMPA",
    "code": "LP-359",
    "hex": "#7F807D",
    "column": 5,
    "position": 33
  },
  {
    "name": "JACKSONVILLE",
    "code": "LP-360",
    "hex": "#5B6266",
    "column": 5,
    "position": 34
  },
  {
    "name": "KEY WEST",
    "code": "LP-361",
    "hex": "#424441",
    "column": 5,
    "position": 35
  },
  {
    "name": "FORT MYERS",
    "code": "LP-362",
    "hex": "#2F2F31",
    "column": 5,
    "position": 36
  },
  {
    "name": "SEATTLE",
    "code": "LP-363",
    "hex": "#D0C6BE",
    "column": 5,
    "position": 37
  },
  {
    "name": "PORTLAND",
    "code": "LP-364",
    "hex": "#917C79",
    "column": 5,
    "position": 38
  },
  {
    "name": "LAS VEGAS",
    "code": "LP-365",
    "hex": "#755E5F",
    "column": 5,
    "position": 39
  },
  {
    "name": "DETROIT",
    "code": "LP-366",
    "hex": "#564342",
    "column": 5,
    "position": 40
  },
  {
    "name": "BALTIMORE",
    "code": "LP-367",
    "hex": "#3F292C",
    "column": 6,
    "position": 1
  },
  {
    "name": "DUBAI",
    "code": "LP-378",
    "hex": "#78CD6E",
    "column": 6,
    "position": 2
  },
  {
    "name": "SAU PAULO",
    "code": "LP-379",
    "hex": "#2A57AF",
    "column": 6,
    "position": 3
  },
  {
    "name": "SANTIAGO",
    "code": "LP-380",
    "hex": "#EF2C9C",
    "column": 6,
    "position": 4
  },
  {
    "name": "TRNSPRNT WHITE",
    "code": "LP-390",
    "hex": "#FFFFFF",
    "column": 6,
    "position": 5
  },
  {
    "name": "TRNSPRNT BLACK",
    "code": "LP-391",
    "hex": "#6F6D6D",
    "column": 6,
    "position": 6
  },
  {
    "name": "TRNSPRNT BROWN",
    "code": "LP-392",
    "hex": "#8B6F67",
    "column": 6,
    "position": 7
  },
  {
    "name": "TRNSPRNT GREEN",
    "code": "LP-393",
    "hex": "#6C8063",
    "column": 6,
    "position": 8
  },
  {
    "name": "TRNSPRNT BLUE",
    "code": "LP-394",
    "hex": "#4A6171",
    "column": 6,
    "position": 9
  },
  {
    "name": "TRNSPRNT RED",
    "code": "LP-395",
    "hex": "#B4625B",
    "column": 6,
    "position": 10
  },
  {
    "name": "FLUO YELLOW",
    "code": "LP-410",
    "hex": "#FFF200",
    "column": 6,
    "position": 11
  },
  {
    "name": "FLUO ORANGE",
    "code": "LP-411",
    "hex": "#F57C14",
    "column": 6,
    "position": 12
  },
  {
    "name": "FLUO RED",
    "code": "LP-412",
    "hex": "#EF3120",
    "column": 6,
    "position": 13
  },
  {
    "name": "FLUO PINK",
    "code": "LP-413",
    "hex": "#ED114E",
    "column": 6,
    "position": 14
  },
  {
    "name": "FLUO BLUE",
    "code": "LP-409",
    "hex": "#00ADEF",
    "column": 6,
    "position": 15
  },
  {
    "name": "FLUO GREEN",
    "code": "LP-414",
    "hex": "#4DBD38",
    "column": 6,
    "position": 16
  },
  {
    "name": "BLACK ASPHALT",
    "code": "LP-438",
    "hex": "#231F20",
    "column": 6,
    "position": 17
  },
  {
    "name": "NEON GREEN",
    "code": "LP-500",
    "hex": "#F2F8CC",
    "column": 6,
    "position": 18
  },
  {
    "name": "HEAVYMETAL SILVER",
    "code": "LP-400",
    "hex": "#B9B7B7",
    "column": 6,
    "position": 19
  },
  {
    "name": "HEAVYMETAL GOLD",
    "code": "LP-401",
    "hex": "#BEA98A",
    "column": 6,
    "position": 20
  },
  {
    "name": "HEAVYMETAL COPPER",
    "code": "LP-402",
    "hex": "#C19E88",
    "column": 6,
    "position": 21
  }
]);
